module.exports = __webpack_public_path__ + "static/calefaccion-e4e31ad271c828ac32530f0dbad9c737.jpg";